<template>
  <div class="section rounded-xl p-5 bg-white border">
    <div class="header mb-2">
      <h3 class="title text-lg font-semibold text-gray-900">{{ title }}</h3>
      <p v-if="helper" class="helper text-sm text-gray-600 mt-1">{{ helper }}</p>
    </div>
    <div class="body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionCard',
  props: {
    title: { type: String, required: true },
    helper: { type: String, default: '' }
  }
}
</script>

<style scoped>
.section { margin: 12px 0; }
.title { margin: 0; }
.helper { margin: 0; }
.body { margin-top: 6px; }
</style>
